import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { take } from 'rxjs';
import { BaseSearchViewDirective } from '@app/shared/base-views/base-search-view.directive';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { ProductLogicService } from '@app/logic/products';
import { TableComponent, USER_CACHE_AREA } from 'cb-hub-lib';
import { ToastService } from '@app/core/services/toast/toast.service';
import { UserCacheService } from '@app/core/services/user-cache/user-cache.service';
import { IProductSpecTemplateUsageDto } from '@classictechsolutions/hubapi-transpiled-enums';

@Component({
    selector: 'cb-item-usage-spec-template-tab',
    templateUrl: './item-usage-spec-template-tab.component.html',
    styleUrls: ['./item-usage-spec-template-tab.component.scss'],
    providers: [NavigationService],
    standalone: false
})
export class ItemUsageSpecTemplateTabComponent extends BaseSearchViewDirective<any> implements OnInit, AfterContentChecked {
    @Input() public productId: number;
    @ViewChild('infiniteScrollTable', { static: false }) public infiniteScrollTable: TableComponent;

    public viewSpecTemplate(specTemplateUsageDto: IProductSpecTemplateUsageDto): void {
        if (specTemplateUsageDto.isScheduleSpecTemplate) {
            this.navigationService.navigate([`/spec-schedule-templates/view/${specTemplateUsageDto.specTemplateId}`]);
        } else {
            this.navigationService.navigate([`/spec-templates/view/${specTemplateUsageDto.specTemplateId}/template`]);
        }
    }

    constructor(
        public readonly navigationService: NavigationService,
        public readonly productLogicService: ProductLogicService,
        public readonly toastSerivce: ToastService,
        public readonly userCacheService: UserCacheService,
        private readonly cdref: ChangeDetectorRef) {

        super(
            productLogicService,
            toastSerivce,
            userCacheService,
            USER_CACHE_AREA.BuildActivitySearch,
        );
    }

    public ngOnInit(): void {
        this.loadSearchParams();
    }

    public ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }

    public doSearch = (): void => {
        if (this.shouldDoSearch()) {
            this.doSearchIfNoScrollBar();
            this.currentPage++;
            this.searchIsLoading = true;
            this.productLogicService
                .getProductSpecTemplateUsage(this.productId, {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                }).pipe(take(1)).subscribe({
                    next: this.handleSearchResult,
                    error: this.handleSearchError
                });
        }
    };
}
